import { apiJson } from '@/lib/api-client';

export interface ResortPlanCount {
  planId: number;
  planSlug: string;
  planName: string;
  ownerCount: number;
}

export interface ResortOwnerStat {
  ownerId: number;
  ownerName: string;
  ownerEmail: string;
  planId: number;
  subscriptionPlan: string;
  planName: string;
  propertyCount: number;
}

export interface ResortStat {
  developmentId: number;
  name: string;
  city: string | null;
  state: string | null;
  isActive: boolean;
  logo: string | null;
  coverImage: string | null;
  propertyCount: number;
  ownerCount: number;
  avgPricePerNight: number | null;
  minPricePerNight: number | null;
  maxPricePerNight: number | null;
  availabilityPeriodsCount: number;
  owners: ResortOwnerStat[];
  ownersByPlan: ResortPlanCount[];
}

export interface ResortsDashboardStats {
  summary: {
    totalDevelopments: number;
    activeDevelopments: number;
    totalProperties: number;
    totalOwnersWithProperties: number;
    overallAvgPricePerNight: number | null;
    propertiesWithoutResort: number;
    ownersWithoutResort: number;
    livePlanOwnersCount: number;
  };
  resorts: ResortStat[];
  unassigned: {
    propertyCount: number;
    ownerCount: number;
    avgPricePerNight: number | null;
  };
}

export class ResortService {
  static async getDashboardStats(): Promise<ResortsDashboardStats> {
    return apiJson<ResortsDashboardStats>('api/developments/admin/dashboard');
  }
}
